import React, { Fragment }        from "react";
import AppBar                     from "@mui/material/AppBar";
import Toolbar                    from "@mui/material/Toolbar";
import IconButton                 from "@mui/material/IconButton";
import ArrowBackIcon              from "@mui/icons-material/ArrowBack";
import { lightTheme, PAYTM_TAB }  from "_root/config/index";
import { DEFAULT_AVATAR_LOGO }    from "_config/index";
import { thirdPartyUiCheck }      from "_common/utils";
import { isInsideThirdPartyApp }  from "_root/thirdParty";
import { RooterLogoBlack }        from "_public/new_design";
import DrawerNav                  from "_components/organisms/drawer";
import useStyles                  from "_styles/organisms/header";
import Image                      from "_components/atoms/image";
import { useSetInterestialPopup } from "_common/hooks/global";
import {
	DailyTaskIcon,
	SearchIcon,
	AvatarIcon
}      from "_assets/index";
import { useGetLoggedIn, useGetProfileData } from "_common/hooks/auth";

const component = props => {
	const {
		hidden,
		goBackToPreviousPage,
		setHeader,
		Router,
		handleGAEvent
	} = props;

	const thirdPartyApp       = isInsideThirdPartyApp ();
	const classes             = useStyles ();
	const setInterestialPopup = useSetInterestialPopup ();

	const userProfileData  = useGetProfileData ();
	const userProfilePhoto = userProfileData?.photo;
	const isLoggedIn       = useGetLoggedIn ();

	const handleIconClick = () => {
		setInterestialPopup ( true );
		handleGAEvent ( "rewardsIcon" );
	};

	return (
		<div
			className = { classes.root }
			style =  { {
				display  : hidden && "none",
				position : "fixed",
				top      : "0",
				width    : "100%",
				zIndex   : "500"
			} }
		>
			<AppBar
				className = { classes.headerStyles }
			>
				<Toolbar
					className = { classes.toolbar }
					style = { { padding: "0 6px", borderBottom: thirdPartyApp !== PAYTM_TAB ? "unset" : "1px solid #e7e7e7" } }
				>
					{thirdPartyUiCheck ( "GO_BACK_BUTTON" ) && thirdPartyApp && (
						<IconButton onClick = { goBackToPreviousPage }
							size = "large"
						>
							<ArrowBackIcon style = { { color: "#fff" } } />
						</IconButton>
					)}

					{thirdPartyUiCheck ( "HAMBURGER_BUTTON" ) && (
						<IconButton
							aria-label = "menu"
							color = "inherit"
							edge = "start"
							onClick = { setHeader }
							size = "large"
							style = { {
								justifyContent : "start",
								borderRadius   : "5px",
								padding        : "10px",
								// paddingRight   : "0px",
								marginLeft     : "2px",
								color          : lightTheme.color
							} }
						>

							{
								isLoggedIn ? (
									<Image
										alt          = "Rooter Profile"
										className    = { classes.userAvatar }
										src          = { userProfilePhoto || DEFAULT_AVATAR_LOGO }
									/>
								) :
									<AvatarIcon className = { classes.profileAvatar } />
							}

						</IconButton>
					)}

					<Fragment>
						<div
							className = { classes.title }
							style = { {
								// marginLeft: thirdPartyApp !== PAYTM_TAB ? "10px" : "4px"
							} }
						>
							<IconButton
								onClick = { () => {
									Router.push ( "/" );
									handleGAEvent ( "rooterLogo" );
								} }
								size = "large"
								style = { {
									padding: thirdPartyApp !== PAYTM_TAB ? "6px 12px" : "6px 12px 6px 0"
								} }
							>
								<RooterLogoBlack className = { classes.svgIconLogo } />

							</IconButton>

						</div>

						<div>
							{thirdPartyApp !== PAYTM_TAB && (
								<IconButton
									onClick = { () => thirdPartyApp !== PAYTM_TAB && Router.push ( "/search-suggestions" ) }
									size = "large"
									style = { {
										color   : lightTheme.inputColor,
										// padding : "6px 0px"
										padding : "6px"
									} }
								>
									<SearchIcon className = { classes.svgIconDark } />
								</IconButton>
							)}

							<IconButton onClick = { handleIconClick }
								size = "large"
							>
								<DailyTaskIcon height = "30px"
									width = "30px"
								/>
							</IconButton>
						</div>

						{/* <DownloadRooterButton /> */}
					</Fragment>
				</Toolbar>
			</AppBar>

			<DrawerNav />
		</div>
	);
};

export default component;

